// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"eca5f793","825":"710386e3","879":"63aad52c"}[chunkId] + ".chunk.js";
};